import { CartItemInterface, Maybe, ProductPrice } from '@pylot-data/pylotschema'
import { CurrencyEnum } from '@pylot-data/enums/CurrencyEnum.d'

export const processItemPrice = (
    item: CartItemInterface,
    productPrice: ProductPrice,
    price?: Maybe<number> // Price value override (if the actual value is different from ProductPrice value)
): void => {
    const { value = 0, currency = CurrencyEnum.Usd } = productPrice.final_price
    const discount = productPrice.discount?.amount_off
    price =
        price !== null && typeof price !== 'undefined' ? price : Number(value)
    const rowTotal = price * item.quantity
    item['prices'] = {
        __typename: 'CartItemPrices',
        price: { value, currency },
        row_total: { value: rowTotal, currency },
        row_total_including_tax: { value: rowTotal, currency },
        total_item_discount: {
            value: Number(discount)
        }
    }
}
